import React, { useState, useEffect } from 'react';
import { Box, Modal, Typography, TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Form } from 'reactstrap';
import axios from 'axios';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { styled } from '@material-ui/core/styles';
import swal from 'sweetalert';
import IpgoItemSerche from './IpgoItemSerche';
import IpgoGumsa from './IpgoGumsa';
import IpgoPrint from './IpgoPrint';
import { useStoresIpgo } from '../UseStores/UseStore';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 600,
  width: 1000,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderColor: 'primary.light',
  boxShadow: 24,
  p: 3,
};
const panelStyle = {
  position: 'absolute',
  top: '11.6%',
  left: '50%',
  bgcolor: 'background.paper',
  //border: '1px solid #000',
  borderColor: '#59b9ea',
  // marginTop:-10,
  //marginLeft: 10,
  height: 84,
  width: 480,
};
const InspStyle = {
  position: 'absolute',
  top: '42%',
  left: '73%',
  bgcolor: 'background.paper',
  //border: '1px solid #000',
  borderColor: 'primary.light',
  //marginTop:-10,
  //marginLeft: 10,
  height: 102,
  width: 250,
};
const findStyle = {
  position: 'absolute',
  top: '44%',
  left: '2%',
  //border: '1px solid #000',
  // marginTop:-10,
  // marginLeft: 55,
  input: { textAlign: 'center' }, //글자가운데 정렬
  height: 37,
  width: 460,
};
const InspBtnStyle = {
  position: 'absolute',
  top: '10%',
  left: '65%',
  //bgcolor: 'background.paper',
  //border: '1px solid red',
  borderColor: 'primary.light',
  background: '#007200',
  color: 'white',
  // marginTop:-10,
  //marginLeft: 10,
  height: 80,
  width: 80,
};
//select 스크롤메뉴높이설정
const selectMenu작업공정Styles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  menuPaper: {
    maxHeight: 520,
  },
}));
//select 스크롤메뉴높이설정
const selectMenu보관위치Styles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  menuPaper: {
    maxHeight: 250,
  },
}));
const CssTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: 'green',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});
//디세이블 설정부분
const DisabledTextField = styled(TextField)({
  //디세이블시 폰트색상
  '& .MuiInputLabel-root': {
    color: 'green',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },
    '&:hover fieldset': {
      borderColor: 'red',
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'red',
    },
  },
});
const CssFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: 'green',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});
const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
    color: 'red',
  },
});
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginTop: theme.spacing(1.2),
    //marginLeft: theme.spacing(0.3),
    // marginRight: theme.spacing(1),
    width: 210,
  },
}));

function IpgoCreate(props) {
  let [seq, setSeq] = useState([]);
  let [orderno, setOrderno] = useState();
  let [changgowicheiopen, setChanggowicheiopen] = useState([]);
  let [changgowichei, setChanggowichei] = useState();
  let [belmeng, setBelmeng] = useState();
  let [worksangtae, setWorksangtae] = useState(); //작업상태
  let [sabun, setSabun] = useState();
  let [cusitem, setCusitem] = useState();
  let [cusname, setCusname] = useState();
  let [sangho, setSangho] = useState();
  let [sanghocode, setSanghocode] = useState();
  let [workcheri, setWorkcheri] = useState();
  let [chericode, setChericode] = useState();
  let [workcherilineopne, setWorkcherilineopne] = useState([]); //작업라인 컨트롤러 쿼리담기
  let [workcherilinecode, setWorkcherilinecode] = useState(); //작업라인변경담기
  let [workprocessopen, setWorkprocessopen] = useState([]); //작업공정순서 컨트롤러 궈리담기
  let [workprocesscode, setWorkprocesscode] = useState(); //작업공정순서
  let [gumsajaopen, setGumsajaopen] = useState([]); //입고검사자컨트롤러 궈리담기
  let [panjung, setPanjung] = useState(); //합부판정
  let [gumsaja, setGumsaja] = useState(); //입고검사자
  let [gumsajahangmug, setGumsajahangmug] = useState(); //검사항목-->입고검수자에서 받아옴
  let [factory, setFactory] = useState(); //작업공정순서
  let [itemmove, setItemmove] = useState(); //공정이동처리방법[입고가 1공장인지 2공장인지 구분]
  let [sumdanga, setSumdanga] = useState();
  let [pimacdanga, setPimacdanga] = useState();
  let [dopodanga, setDopodanga] = useState();
  let [pricesangtae, setPricesangtae] = useState();
  let [gressweight, setGressweight] = useState();
  let [boxeach, setBoxeach] = useState();
  let [ipgoquantity, setIpgoquantity] = useState(0); //입고수량
  let [pimacdaewi, setPimacdaewi] = useState();
  let [dopodaewi, setDopodaewi] = useState();
  let [ipgogumack, setIpgogumack] = useState(0); //입고금액(피막+도포)
  let [ipgopimacgumack, setIpgopimacgumack] = useState(0); //입고피막금액
  let [ipgodopogumack, setIpgodopogumack] = useState(0); //입고도포금액
  let [ipgoupchejunpupqty, setIpgoupchejunpupqty] = useState(0); //업체전표입고수량
  let [ipgoupchelotcode, setIpgoupchelotcode] = useState(); //업체전표입고로트번호
  let [ipgoboxqty, setIpgoboxqty] = useState(); //입고시업체박스수
  let [ipgoticketjundal, setIpgoticketjundal] = useState(); //입고전달사항
  let [ipgoyoochengil, setIpgoyoochengil] = useState(
    moment().format('YYYY-MM-DD HH:mm')
  ); //업체입고요청일자
  let [ipgodatetime, setIpgodatetime] = useState(
    moment().format('YYYY-MM-DD HH:mm')
  ); //입고등록일자
  let [ipgogongyung, setIpgogongyung] = useState(); //공용품번(특수공정으로 사용함)
  let [ipgotowgongjang, setIpgotowgongjang] = useState(); //공장간이동전표출력
  let [radiogroup, setRadiogroup] = useState('customeritem'); // 찾기 라디오버튼
  let [sercheoption, setSercheoption] = useState(); //찾기 옵션선택 엔트키
  let [dataItem, setDataItem] = useState([]);
  let [dbClickValue, setDbClickValue] = useState([]);
  let [copen, setCopen] = useState(false); //우리품번/품번찾기 모달
  let [customergumsaopen, setCustomergumsaopen] = useState(false); //검사항목찾기 모달
  let [ipgoprintopen, setIpgoprintopen] = useState(false); //print 모달
  let [ipgoprintmove, setIpgoprintmove] = useState([]); //print 자료전달
  let [btnunable, setBtneuable] = useState(true); //저장시 등록버튼 비활성화

  let selectMenu작업공정Classes = selectMenu작업공정Styles(); //select메뉴 스크롤높이설정 변수
  let selectMenu보관위치Classes = selectMenu보관위치Styles(); //select메뉴 스크롤높이설정 변수
  const classes = useStyles();

  // console.log(gumsajahangmug); //제이슨가져오기
  // const aaa =JSON.parse(gumsajahangmug); //제이슨을 분해한다
  // console.log((JSON.parse(gumsajahangmug)).balcheng) //제이슨으 해당항목을 불러온다
  //console.log(ipgoyoochengil)

  //작업라인가져오기
  const getJsonLoadWorkOpen = async () => {
    await axios.get('/IpgoReact/IndexWorkLine').then((res) => {
      setWorkcherilineopne(res.data);
    });
  };

  //작업공정순서가져오기
  const getJsonLoadWorkProcess = async () => {
    await axios.get('/IpgoReact/IndexWorkProcess').then((res) => {
      setWorkprocessopen(res.data);
    });
  };
  //입고검사자가져오기
  const getJsonLoadGumSaja = async () => {
    await axios.get('/IpgoReact/IndexWorkGumSaja').then((res) => {
      setGumsajaopen(res.data);
    });
  };
  //창고지정위치 가져오기
  const getJsonLoadWiChi = async () => {
    await axios.get('/IpgoReact/IndexWorkIpgoWiChei').then((res) => {
      setChanggowicheiopen(res.data);
    });
  };

  useEffect(() => {
    getJsonLoadWorkOpen(); //작업라인
    //console.log("작업라인");
  }, []);

  useEffect(() => {
    getJsonLoadWorkProcess(); //작업공정순서
    //console.log("공정순서");
  }, []);

  useEffect(() => {
    getJsonLoadGumSaja(); //입고검사자
    //console.log("검사자");
  }, []);
  useEffect(() => {
    getJsonLoadWiChi(); //창고지정위치
    //console.log("창고위치");
  }, [setChanggowichei]);
  //console.log(changgowichei)

  useEffect(() => {
    setBelmeng(dbClickValue.item_bel_meng);
    setSabun(dbClickValue.item);
    setCusitem(dbClickValue.item_upche_item);
    setCusname(dbClickValue.item_upche_name);
    setSangho(dbClickValue.item_upche_sangho);
    setSanghocode(dbClickValue.item_upche_code);
    setWorkcheri(dbClickValue.item_work_cheri_description);
    setChericode(dbClickValue.item_cheri_code);
    //작업라인 해당조건 저장하기
    workcherilineopne.forEach((cheriwork) => {
      if (
        cheriwork.upche_price_cheri_work === dbClickValue.item_work_cheri_line
      ) {
        setWorkcherilinecode(cheriwork.upche_price_cheri_work);
      }
    });
    //최종공정라인 해당조건 저장하기
    workprocessopen.forEach((itemcheri) => {
      if (itemcheri.item_cheri === dbClickValue.item_최종공정라인) {
        setWorkprocesscode(itemcheri.item_cheri);
      }
    });

    setFactory(dbClickValue.item_factory); //공장구분
    setItemmove(dbClickValue.item_이동처리방법); //입고가 1공장인지 2공장인지 구분
    setSumdanga(dbClickValue.item_danga);
    setPimacdanga(dbClickValue.item_danga_pimac);
    setDopodanga(dbClickValue.item_danga_dopo);
    setPricesangtae(dbClickValue.item_price_sangtae);
    setGressweight(dbClickValue.item_gress_weight);
    setBoxeach(dbClickValue.item_box_each);
    setPimacdaewi(dbClickValue.item_daewi);
    setDopodaewi(dbClickValue.item_do_danwie);
    setIpgogongyung(dbClickValue.item_공용품번);
    setIpgotowgongjang(dbClickValue.item_공장간이동전표출력);
    setWorksangtae('생산대기');
  }, [dbClickValue, workcherilineopne, workprocessopen, dataItem]);

  //console.log(`여기:${ipgogongyung}`);
  //console.log(`여기:${dbClickValue.item_공장간이동전표출력}`);

  let ordernoHandle = (e) => {
    e.preventDefault();
    setOrderno(e.target.value);
  };
  let changgowicheiHandle = (e) => {
    e.preventDefault();
    setChanggowichei(e.target.value);
  };
  let belmengHandle = (e) => {
    e.preventDefault();
    setBelmeng(e.target.value);
  };
  //작업상태
  let worksangtaeHandle = (e) => {
    e.preventDefault();
    setWorksangtae(e.target.value);
  };
  let sabunHandle = (e) => {
    e.preventDefault();
    setSabun(e.target.value);
  };
  let cusitemHandle = (e) => {
    e.preventDefault();
    setCusitem(e.target.value);
  };
  let cusnameHandle = (e) => {
    e.preventDefault();
    setCusname(e.target.value);
  };
  let sanghoHandle = (e) => {
    e.preventDefault();
    setSangho(e.target.value);
  };
  let sanghocodeHandle = (e) => {
    e.preventDefault();
    setSanghocode(e.target.value);
  };
  let workcheriHandle = (e) => {
    e.preventDefault();
    setWorkcheri(e.target.value);
  };
  let chericodeHandle = (e) => {
    e.preventDefault();
    setChericode(e.target.value);
  };
  let workcherilinecodeHandle = (e) => {
    e.preventDefault();
    setWorkcherilinecode(e.target.value);
  };
  let workprocesscodeHandle = (e) => {
    e.preventDefault();
    setWorkprocesscode(e.target.value);
  };
  let gumsajaHandle = (e) => {
    e.preventDefault();
    setGumsaja(e.target.value);
  };
  let panjungHandle = (e) => {
    e.preventDefault();
    setPanjung(e.target.value);
  };
  let gumsajahangmugHandle = () => {
    if (gumsajahangmug === undefined) {
      setCustomergumsaopen(true);
      // console.log(gumsajahangmug) //제이슨으 해당항목을 불러온다
      // console.log("검사항목불러오기[첫번째실패]") //제이슨으 해당항목을 불러온다
    } else if (gumsajahangmug === '') {
      // console.log('검사항목불러오기[공란처리]') //제이슨으 해당항목을 불러온다
      setCustomergumsaopen(true);
      // console.log(gumsajahangmug) //제이슨으 해당항목을 불러온다
    } else {
      // console.log('검사항목불러오기[첫번째성공]') //제이슨으 해당항목을 불러온다
      //console.log(gumsajahangmug) //제이슨으 해당항목을 불러온다
      // console.log(JSON.par'se(gumsajahangmug).balcheng) //제이슨으 해당항목을 불러온다
    }
  };
  let factoryHandle = (e) => {
    e.preventDefault();
    setFactory(e.target.value);
  };
  let itemmoveHandle = (e) => {
    e.preventDefault();
    setItemmove(e.target.value);
  };
  let sumdangaHandle = (e) => {
    e.preventDefault();
    setSumdanga(e.target.value);
  };
  let pimacdangaHandle = (e) => {
    e.preventDefault();
    setPimacdanga(e.target.value);
  };
  let dopodangaHandle = (e) => {
    e.preventDefault();
    setDopodanga(e.target.value);
  };
  let pricesangtaeHandle = (e) => {
    e.preventDefault();
    setPricesangtae(e.target.value);
  };
  let gressweightHandle = (e) => {
    e.preventDefault();
    setGressweight(e.target.value);
  };
  let boxeachHandle = (e) => {
    e.preventDefault();
    setBoxeach(e.target.value);
  };
  let ipgoquantityHandle = (e) => {
    e.preventDefault();
    setIpgoquantity(e.target.value);
    setIpgogumack(e.target.value * sumdanga);
    setIpgopimacgumack(e.target.value * pimacdanga);
    setIpgodopogumack(e.target.value * dopodanga);
  };
  let pimacdanwieHandle = (e) => {
    e.preventDefault();
    setPimacdaewi(e.target.value);
  };
  let dopodanwieHandle = (e) => {
    e.preventDefault();
    setDopodaewi(e.target.value);
  };
  let ipgogumackHandle = (e) => {
    e.preventDefault();
    setIpgogumack(e.target.value);
  };
  let ipgopimacgumackHandle = (e) => {
    e.preventDefault();
    setIpgopimacgumack(e.target.value);
  };
  let ipgodopogumackHandle = (e) => {
    e.preventDefault();
    setIpgodopogumack(e.target.value);
  };
  let ipgoupchejunpupqtyHandle = (e) => {
    e.preventDefault();
    setIpgoupchejunpupqty(e.target.value);
  };
  let ipgoupchelotcodeHandle = (e) => {
    e.preventDefault();
    setIpgoupchelotcode(e.target.value);
  };
  //입고시업체박스
  let ipgoboxqtyHandle = (e) => {
    e.preventDefault();
    setIpgoboxqty(e.target.value);
  };
  let ipgoticketjundalHandle = (e) => {
    e.preventDefault();
    setIpgoticketjundal(e.target.value);
  };

  let ipgoyoochengilHandle = (e) => {
    e.preventDefault();
    setIpgoyoochengil(moment(e.target.value).format('YYYY-MM-DD HH:mm'));
  };

  let ipgodatetimeHandle = (e) => {
    e.preventDefault();
    setIpgodatetime(moment(e.target.value).format('YYYY-MM-DD HH:mm'));
  };

  let radiogroupHandle = (e) => {
    e.preventDefault();
    setRadiogroup(e.target.value);
  };
  //onsole.log(radiogroup);

  let sercheoptionHandle = (e) => {
    e.preventDefault();
    setSercheoption(e.target.value.toUpperCase());
  };
  let ipgotowgongjangHandle = (e) => {
    e.preventDefault();
    setIpgotowgongjang(e.target.value);
  };

  //클릭시 항목삭제
  let clearclickHandle = (e) => {
    e.preventDefault();
    setSeq([]);
    setOrderno('');
    setChanggowichei('');
    setBelmeng('');
    setWorksangtae('');
    setSabun('');
    setCusitem('');
    setCusname('');
    setSangho('');
    setSanghocode('');
    setWorkcheri('');
    setChericode('');
    setPanjung('');
    setGumsaja('');
    setGumsajahangmug('');
    setFactory('');
    setItemmove('');
    setSumdanga('');
    setPimacdanga('');
    setDopodanga('');
    setPricesangtae('');
    setGressweight('');
    setBoxeach('');
    setIpgoquantity();
    setPimacdaewi('');
    setDopodaewi('');
    setIpgogumack(0);
    setIpgopimacgumack(0);
    setIpgodopogumack(0);
    setWorkcherilinecode();
    setWorkprocesscode();
    setIpgoupchejunpupqty('');
    setIpgoupchelotcode('');
    setIpgoboxqty('');
    setIpgoticketjundal('');
    setIpgoyoochengil(moment().format('YYYY-MM-DD HH:mm'));
    setIpgodatetime(moment().format('YYYY-MM-DD HH:mm'));
    setIpgogongyung(''); //공용품번
    setIpgotowgongjang(''); //공장간이동전표출력 있음 없음
  };

  let enterSercheHandle = (e) => {
    if (e.key === 'Enter') {
      //e.preventDefault();
      //const evValue = new FormData(e.currentTarget);
      //const valueOp = e.get("c03");
      //const valueCitem = e.get("serche");
      const sercheFind = {
        radiogroup: radiogroup,
        sercheoption: sercheoption,
      };
      axios
        .get(`/IpgoReact/IndexCusItem?InputVariable=${sercheFind.sercheoption}&OpVariable=${sercheFind.radiogroup}`)
        .then((res) => setDataItem(res.data));
      setCopen(true);
    }
  };
  //등록버튼 클릭시 작업지시호생성
  const buttonClickHeandle = () => {
    axios.get(`/IpgoReact/IndexWorkIpgoSEQ`).then((res) => setSeq(res.data));
    seq.map(() => setOrderno(seq[0].suju_ipgo_seq_seqno + 1));
  };

  //입고버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    let ipgoCreate = {
      ipgo_item_auto: orderno, //작지번호
      ipgo_item_bel_meng: belmeng, //별명
      ipgo_item_yn: worksangtae, //작업상태
      ipgo_item: sabun, //우리품번
      ipgo_item_upche_item: cusitem, //업체품번
      //cusitem:cusitem, //찾기값
      ipgo_item_upche_name: cusname, //품명
      ipgo_item_upche_sangho: sangho, //업체상호
      ipgo_upche_code: sanghocode, //업체코드
      ipgo_item_cheri_desc: workcheri, //시작공정
      ipgo_item_cheri_code: chericode, //처리코드
      ipgo_item_work_cheri_line: workcherilinecode, //작업라인
      ipgo_최종공정라인: workprocesscode, //작업공정
      ipgo_factory: factory, //공장구분
      ipgo_ipgojangso: itemmove, //입고장소[하역장소] 공정이동처리방법[입고가 1공장인지 2공장인지 구분]
      ipgo_item_danga: sumdanga, //S단가
      ipgo_item_danga_pimac: pimacdanga, //피막단가
      ipgo_item_danga_dopo: dopodanga, //도포단가
      ipgo_item_price_sangtae: pricesangtae, //단가상태
      ipgo_gress_weight: gressweight, //개당중량
      ipgo_dangrang: boxeach, //박수당량
      ipgo_item_quantity: ipgoquantity, //입고수량
      ipgo_item_daewi: pimacdaewi, //피막단위
      ipgo_item_do_danwie: dopodaewi, //도포단위
      ipgo_item_gumhag: ipgogumack, //입고금액
      ipgo_item_pimac_gumhag: ipgopimacgumack, //피막금액
      ipgo_item_dopo_gumhag: ipgodopogumack, //도포금액
      ipgo_upche_jun_pup_qty: ipgoupchejunpupqty, //업체전표수량
      ipgo_upche_lot_code: ipgoupchelotcode, //업체로트번호
      ipgo_ticket_jundal: ipgoboxqty, // 일반전달사항[박스...]
      ipgo_wi_chi: changgowichei, //창고위치
      ipgo_item_description: ipgoticketjundal, //제품전달사항
      ipgo_item_ipgo_yoocheng_il:
        moment(ipgoyoochengil).format('YYYY-MM-DD HH:mm'), //작업완료요청일자
      ipgo_item_datetime: moment(ipgodatetime).format('YYYY-MM-DD HH:mm'), //등록일자
      ipgo_item_qc_inspection: panjung, //판정
      ipgo_item_qc_gumsuja: gumsaja, //검사자
      ipgo_공용품번: ipgogongyung, //공용품번(특별공정항목으로 사용함.)
      ipgo_공장간이동전표출력: ipgotowgongjang, //공장간이동전표출력
      //q_suip_inspection 파일에 저장시킬것(개별로 넘길것)
      balcheng: JSON.parse(gumsajahangmug).balcheng,
      youbun: JSON.parse(gumsajahangmug).youbun,
      lijung: JSON.parse(gumsajahangmug).lijung,
      gongjung: JSON.parse(gumsajahangmug).gongjung,
      burr: JSON.parse(gumsajahangmug).burr,
    };

    setIpgoprintmove(ipgoCreate); //프린트로 자료전달
    setBtneuable(false);
    // console.log(ipgoprintmove);

    axios
      .post(`/IpgoReact/Create`, ipgoCreate, {
        params: {
          Balcheng: ipgoCreate.balcheng,
          Youbun: ipgoCreate.youbun,
          Lijung: ipgoCreate.lijung,
          Gongjung: ipgoCreate.gongjung,
          Burr: ipgoCreate.burr,
        },
      })
      .then((response) => {
        //정상적으로 처리됨
        if (response.status === 200) {
          //console.log("정상저장")
          //console.log(response.status)
          //props.setAdd(false); //모달닫기
          props.setDbOpen(true); //자료등록시 재랜드링
          props.setEsave(true); //저장모달열기

          setIpgoprintopen(true); //프린트 모달 오픈

        }
      })
      .catch((error) => {
        // 오류발생시 실행
        if (error.response.status === 404) {
          //console.log("에라발생")
          //console.log(error.response)
          props.setAdd(false); //모달닫기
          props.setEerror(true); //에라모달열기
        }
      });
  };

  //검사항목 모달실행
  let gumsaInsertHandle = (e) => {
    setCustomergumsaopen(true);
  };

  // 인쇄 기능 Handler
  const onPrintHandler = () => {
    useStoresIpgo.setState({ ipgoprintopentrue: false }); //주스텐드 ture 스테이트 변경
    useStoresIpgo.setState({ ipgoprintopenhangmok: '' }); //주스텐드 스테이터 변경
    if (ipgoprintmove.ipgo_item_auto === undefined) {
      swal('입고등록되지 않아 출력을 할수가 \n 없습니다.', {
        button: { text: '닫기' },
        timer: 5000,
      });
    } else {
      setIpgoprintopen(true); //프린트 모달 오픈
    }
  };

  return (
    <div>
      <Modal open={props.add}>
        <Box sx={style}>
          <div>
            <Typography
              id="modal-modal-titledlq"
              style={{
                fontFamily: 'D2Coding',
                fontSize: '24px',
                color: 'green',
              }}
            >
              {/* <CircleIcon style={{fontSize:'10px'}}/> */}
              입고등록
              {/* <CircleIcon style={{fontSize:'10px'}}/> */}
            </Typography>
          </div>
          <Form onSubmit={handleSubmit}>
            <div>
              <TextField
                disabled
                onChange={ordernoHandle}
                style={{
                  width: 100,
                  marginTop: '10px',
                  float: 'center',
                  marginRight: '2px',
                }}
                //margin="normal"
                required
                variant="outlined"
                InputLabelProps={
                  orderno === '' ? { shrink: false } : { shrink: true }
                }
                id=""
                label="작지번호"
                name=""
                size="small"
                value={orderno ? orderno : ''}
              />
              <TextField
                disabled
                onChange={belmengHandle}
                style={{
                  width: 150,
                  marginTop: '10px',
                  float: 'center',
                  marginRight: '2px',
                }}
                //margin="normal"
                //requiredpanjungHandle
                variant="outlined"
                InputLabelProps={
                  belmeng === '' ? { shrink: false } : { shrink: true }
                }
                id="outlined-uncontrolled"
                label="별명"
                name="belmeng"
                size="small"
                value={belmeng ? belmeng : ''}
              />
              <TextField
                disabled
                onChange={worksangtaeHandle}
                style={{
                  width: 100,
                  marginTop: '10px',
                  float: 'center',
                  marginRight: '2px',
                }}
                //margin="normal"
                //requiredpanjungHandle
                variant="outlined"
                InputLabelProps={
                  worksangtae === '' ? { shrink: false } : { shrink: true }
                }
                id="outlined-uncontrolled"
                label="작업상태"
                name="worksangtae"
                size="small"
                value={worksangtae ? worksangtae : ''}
              />
              <Paper variant="outlined" square style={panelStyle}>
                <RadioGroup
                  row
                  value={radiogroup}
                  onChange={radiogroupHandle}
                  defaultValue="customeritem"
                >
                  <FormControlLabel
                    style={{ marginLeft: 4 }}
                    value="bulmum"
                    control={<Radio size="small" />}
                    label="별명"
                  />
                  <FormControlLabel
                    value="item"
                    control={<Radio size="small" />}
                    label="우리"
                  />
                  <FormControlLabel
                    value="customeritem"
                    control={<Radio size="small" />}
                    label="품번"
                  />
                  <FormControlLabel
                    value="name"
                    control={<Radio size="small" />}
                    label="품명"
                  />
                  <FormControlLabel
                    value="customer"
                    control={<Radio size="small" />}
                    label="업체"
                  />
                  <FormControlLabel
                    disabled
                    value="sangwi"
                    control={<Radio size="small" />}
                    label="상위"
                  />
                </RadioGroup>
                <TextField
                  onChange={sercheoptionHandle}
                  onKeyDown={enterSercheHandle}
                  onClick={clearclickHandle}
                  style={findStyle}
                  value={sercheoption ? sercheoption : ''} //대문자변경처리 할수 있음
                  //margin="normal"
                  //required
                  variant="outlined"
                  id="sercheoption"
                  label="입력후Enter"
                  name="sercheoption"
                  size="small"
                />
              </Paper>
            </div>
            <Paper square variant="outlined" style={InspStyle}>
              <FormControl
                required
                variant="outlined"
                style={{ minWidth: 150, marginTop: '10px', marginLeft: '6px' }}
                size="small"
              >
                <InputLabel id="demo-simple-select-autowidth-label">
                  판정
                </InputLabel>
                <CssSelect
                  variant="outlined"
                  value={panjung ? panjung : ''}
                  onChange={panjungHandle}
                  label="판정"
                >
                  <MenuItem value="">
                    <em>-None</em>
                  </MenuItem>
                  <MenuItem value={'합격'}>합격</MenuItem>
                  <MenuItem value={'불합격'}>불합격</MenuItem>
                </CssSelect>
              </FormControl>

              <FormControl
                required
                variant="outlined"
                style={{ minWidth: 150, marginTop: '8px', marginLeft: '6px' }}
                size="small"
              >
                <InputLabel id="demo-simple-select-autowidth-label">
                  검사자
                </InputLabel>
                <CssSelect
                  variant="outlined"
                  value={gumsaja ? gumsaja : setGumsaja([])}
                  onChange={gumsajaHandle}
                  label="검사자"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {gumsajaopen.map((name) => (
                    <MenuItem key={name.id} value={name.inspection_gunsuja}>
                      {name.inspection_gunsuja}
                    </MenuItem>
                  ))}
                </CssSelect>
              </FormControl>
              <Button
                variant="contained"
                size="small"
                style={InspBtnStyle}
                onClick={gumsaInsertHandle}
              >
                검사
                <br />
                항목
              </Button>
            </Paper>
            <div></div>
            <CssTextField
              disabled
              onChange={sabunHandle}
              style={{
                width: 150,
                marginTop: '10px',
                float: 'center',
                marginRight: '2px',
              }}
              //margin="normal"
              required
              variant="outlined"
              InputLabelProps={
                sabun === '' ? { shrink: false } : { shrink: true }
              }
              id=""
              label="우리품번"
              name="sabun"
              size="small"
              value={sabun ? sabun : ''}
            />
            <CssTextField
              disabled
              onChange={cusitemHandle}
              style={{
                width: 150,
                marginTop: '10px',
                float: 'center',
                marginRight: '2px',
              }}
              //margin="normal"
              //required
              variant="outlined"
              InputLabelProps={
                cusitem === '' ? { shrink: false } : { shrink: true }
              }
              id=""
              label="업체품번"
              name="cusitem"
              size="small"
              value={cusitem ? cusitem : ''}
            />
            <TextField
              disabled
              onChange={cusnameHandle}
              style={{
                ml: 0,
                width: 150,
                marginTop: '10px',
                float: 'center',
                marginRight: '2px',
              }}
              //margin="normal"
              //required
              variant="outlined"
              InputLabelProps={
                cusname === '' ? { shrink: false } : { shrink: true }
              }
              id="outlined-uncontrolled"
              label="품명"
              name="cusname"
              size="small"
              value={cusname ? cusname : ''}
            />
            <div>
              <div>
                <TextField
                  disabled
                  onChange={sanghoHandle}
                  style={{
                    width: 150,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    sangho === '' ? { shrink: false } : { shrink: true }
                  }
                  id="sangho"
                  label="업체상호"
                  name="sangho"
                  size="small"
                  value={sangho ? sangho : ''}
                />
                <TextField
                  disabled
                  onChange={sanghocodeHandle}
                  style={{ width: 80, marginTop: '10px', float: 'center' }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    sanghocode === '' ? { shrink: false } : { shrink: true }
                  }
                  id="sanghocode"
                  label="코드"
                  name="sanghocode"
                  size="small"
                  value={sanghocode ? sanghocode : ''}
                />
              </div>
              <div>
                <TextField
                  disabled
                  onChange={workcheriHandle}
                  style={{
                    width: 110,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    workcheri === '' ? { shrink: false } : { shrink: true }
                  }
                  id="workcheri"
                  label="시작공정"
                  name="workcheric02"
                  size="small"
                  value={workcheri ? workcheri : ''}
                />
                <TextField
                  disabled
                  onChange={chericodeHandle}
                  style={{
                    ml: 0,
                    width: 110,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    chericode === '' ? { shrink: false } : { shrink: true }
                  }
                  id="chericode"
                  label="종료코드"
                  name="chericode"
                  size="small"
                  value={chericode ? chericode : ''}
                />

                <CssFormControl
                  required
                  variant="outlined"
                  style={{
                    minWidth: 110,
                    marginTop: '10px',
                    marginRight: '2px',
                  }}
                  size="small"
                >
                  <InputLabel
                    style={{ align: 'center' }}
                    id="demo-simple-select-autowidth-label"
                  >
                    작업라인
                  </InputLabel>
                  <Select
                    value={
                      workcherilinecode
                        ? workcherilinecode
                        : setWorkcherilinecode([])
                    }
                    onChange={workcherilinecodeHandle}
                    variant="outlined"
                    autoWidth
                    label="작업라인"
                  >
                    <MenuItem value="">
                      <em>작업라인</em>
                    </MenuItem>
                    {workcherilineopne.map((name) => (
                      <MenuItem
                        key={name.id}
                        value={name.upche_price_cheri_work}
                      >
                        {name.upche_price_cheri_work}
                      </MenuItem>
                    ))}
                  </Select>
                </CssFormControl>
                <CssFormControl
                  required
                  variant="outlined"
                  style={{
                    minWidth: 150,
                    marginTop: '10px',
                    marginRight: '2px',
                  }}
                  size="small"
                >
                  <InputLabel id="demo-simple-select-autowidth-label">
                    작업공정
                  </InputLabel>
                  <Select
                    value={workprocesscode ? workprocesscode : ''}
                    onChange={workprocesscodeHandle}
                    variant="outlined"
                    autoWidth
                    MenuProps={{
                      classes: { paper: selectMenu작업공정Classes.menuPaper },
                    }} //selectMenuClasses는 상단 메뉴높이이 설정함.
                    label="작업공정"
                  >
                    <MenuItem value="">
                      <em>작업공정</em>
                    </MenuItem>
                    {workprocessopen.map((name) => (
                      <MenuItem key={name.id} value={name.item_cheri}>
                        {name.item_cheri}
                      </MenuItem>
                    ))}
                  </Select>
                </CssFormControl>
                <DisabledTextField
                  disabled
                  onChange={factoryHandle}
                  style={{
                    width: 100,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  error
                  InputLabelProps={
                    factory === '' ? { shrink: false } : { shrink: true }
                  }
                  id="outlined-error"
                  label="계산서발행"
                  name="factoryc02"
                  size="small"
                  value={factory ? factory : ''}
                />
                <TextField
                  disabled
                  onChange={itemmoveHandle}
                  style={{ width: 100, marginTop: '10px', float: 'center' }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    itemmove === '' ? { shrink: false } : { shrink: true }
                  }
                  id="itemmove"
                  label="입고장소"
                  name="itemmove"
                  size="small"
                  value={itemmove ? itemmove : ''}
                />
              </div>
              <div>
                <TextField
                  disabled
                  onChange={sumdangaHandle}
                  style={{
                    width: 80,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    sumdanga === '' ? { shrink: false } : { shrink: true }
                  }
                  id="sumdanga"
                  label="S단가"
                  name="sumdanga"
                  size="small"
                  value={sumdanga ? sumdanga : ''}
                />
                <TextField
                  disabled
                  onChange={pimacdangaHandle}
                  style={{
                    width: 70,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    pimacdanga === '' ? { shrink: false } : { shrink: true }
                  }
                  id="pimacdanga"
                  label="피막"
                  name="pimacdanga"
                  size="small"
                  value={pimacdanga ? pimacdanga : ''}
                />
                <TextField
                  disabled
                  onChange={dopodangaHandle}
                  style={{
                    ml: 0,
                    width: 70,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    dopodanga === '' ? { shrink: false } : { shrink: true }
                  }
                  id="dopodanga"
                  label="도포"
                  name="dopodanga"
                  size="small"
                  value={dopodanga ? dopodanga : ''}
                />
                <TextField
                  disabled
                  onChange={pricesangtaeHandle}
                  style={{
                    width: 100,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    pricesangtae === '' ? { shrink: false } : { shrink: true }
                  }
                  id="pricesangtae"
                  label="단가상태"
                  name="pricesangtae"
                  size="small"
                  value={pricesangtae ? pricesangtae : ''}
                />
                <TextField
                  disabled
                  onChange={gressweightHandle}
                  style={{
                    width: 100,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    gressweight === '' ? { shrink: false } : { shrink: true }
                  }
                  id="gressweight"
                  label="개당중량"
                  name="gressweight"
                  size="small"
                  value={gressweight ? gressweight : ''}
                />
                <TextField
                  disabled
                  onChange={boxeachHandle}
                  style={{
                    width: 100,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  InputLabelProps={
                    boxeach === '' ? { shrink: false } : { shrink: true }
                  }
                  id="boxeach"
                  label="당량"
                  name="boxeach"
                  size="small"
                  value={boxeach ? boxeach : ''}
                />
              </div>
              <div>
                <TextField
                  disabled
                  onChange={pimacdanwieHandle}
                  style={{
                    width: 70,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  variant="outlined"
                  InputLabelProps={
                    pimacdaewi === '' ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="pimacdaewi"
                  label="피단위"
                  name="pimacdaewi"
                  size="small"
                  value={pimacdaewi ? pimacdaewi : ''}
                />
                <TextField
                  disabled
                  onChange={dopodanwieHandle}
                  style={{
                    width: 70,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  variant="outlined"
                  InputLabelProps={
                    dopodaewi === '' ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="dopodaewi"
                  label="도단위"
                  name="dopodaewi"
                  size="small"
                  value={dopodaewi ? dopodaewi : ''}
                />
                <TextField
                  disabled
                  onChange={ipgogumackHandle}
                  style={{
                    width: 120,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  variant="outlined"
                  InputLabelProps={
                    ipgogumack === 0 ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="ipgogumack"
                  label="입고금액"
                  name="ipgogumack"
                  size="small"
                  value={ipgogumack ? ipgogumack : ''}
                />
                <TextField
                  disabled
                  onChange={ipgopimacgumackHandle}
                  style={{
                    width: 100,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  variant="outlined"
                  InputLabelProps={
                    ipgopimacgumack === 0 ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="ipgopimacgumack"
                  label="피막금액"
                  name="ipgopimacgumack"
                  size="small"
                  value={ipgopimacgumack ? ipgopimacgumack : ''}
                />
                <TextField
                  disabled
                  onChange={ipgodopogumackHandle}
                  style={{ width: 100, marginTop: '10px', float: 'center' }}
                  variant="outlined"
                  InputLabelProps={
                    ipgodopogumack === 0 ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="ipgodopogumack"
                  label="도포금액"
                  name="ipgodopogumack"
                  size="small"
                  value={ipgodopogumack ? ipgodopogumack : ''}
                />
              </div>
              <div>
                <CssTextField
                  onChange={ipgoquantityHandle}
                  onClick={gumsajahangmugHandle}
                  inputProps={{ inputMode: 'numeric', pattern: '([^0-9]*)' }}
                  primary={'숫자만 입력됩니다.'}
                  //inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                  style={{
                    width: 150,
                    marginTop: '10px',
                    marginRight: '2px',
                    float: 'center',
                  }}
                  //margin="normal"
                  required
                  variant="outlined"
                  //InputLabelProps={ipgoquantity === true ? {ipgoquantity: false} : {ipgoquantity: true}}
                  type="number"
                  id="c05"
                  label="입고수량"
                  name="ipgoquantity"
                  size="small"
                  value={ipgoquantity ? ipgoquantity : ''}
                />
              </div>

              <div>
                <CssTextField
                  onChange={ipgoupchejunpupqtyHandle}
                  style={{
                    width: 150,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  required
                  variant="outlined"
                  //InputLabelProps={ipgoupchejunpupqty === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoupchejunpupqty"
                  label="업체전표수량"
                  name="ipgoupchejunpupqty"
                  size="small"
                  value={ipgoupchejunpupqty ? ipgoupchejunpupqty : ''}
                />
                <CssTextField
                  onChange={ipgoupchelotcodeHandle}
                  style={{
                    width: 150,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  required
                  variant="outlined"
                  //InputLabelProps={ipgoupchelotcode === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoupchelotcode"
                  label="업체로트No"
                  name="ipgoupchelotcode"
                  size="small"
                  value={ipgoupchelotcode ? ipgoupchelotcode : ''}
                />
                <CssTextField
                  onChange={ipgoboxqtyHandle}
                  style={{
                    width: 150,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  required
                  variant="outlined"
                  //InputLabelProps={ipgoticketjundal === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoboxqty"
                  label="업체입고[박스]"
                  name="ipgoboxqty"
                  size="small"
                  value={ipgoboxqty ? ipgoboxqty : ''}
                />
                <CssFormControl
                  required
                  variant="outlined"
                  style={{
                    minWidth: 110,
                    marginTop: '10px',
                    marginRight: '2px',
                    maxMenuHeight: '10px',
                  }}
                  size="small"
                >
                  <InputLabel style={{ textAlign: 'center' }} id="">
                    보관위치
                  </InputLabel>
                  <Select
                    value={changgowichei ? changgowichei : ''}
                    onChange={changgowicheiHandle}
                    variant="outlined"
                    MenuProps={{
                      classes: { paper: selectMenu보관위치Classes.menuPaper },
                    }} //selectMenuClasses는 상단 메뉴높이이 설정함.
                    //renderInput={(params) => <TextField {...params} variant="standard" label="보관위치" />}
                    label="보관위치"
                  >
                    <MenuItem value="">
                      <em>-빈값-</em>
                    </MenuItem>
                    {changgowicheiopen.map((name, index) => (
                      <MenuItem key={index} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </CssFormControl>
                <TextField
                  onChange={ipgotowgongjangHandle}
                  style={{
                    width: 130,
                    marginTop: '10px',
                    float: 'center',
                    marginRight: '2px',
                  }}
                  disabled
                  variant="outlined"
                  //InputLabelProps={ipgoticketjundal === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgotowgongjang"
                  label="공장간전표출력"
                  name="ipgotowgongjang"
                  size="small"
                  value={ipgotowgongjang ? ipgotowgongjang : ''}
                />
              </div>
              <div>
                <CssTextField
                  onChange={ipgoticketjundalHandle}
                  style={{ width: 350, marginTop: '10px', float: 'center' }}
                  variant="outlined"
                  //InputLabelProps={ipgoticketjundal === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoticketjundal"
                  label="작업전달사항"
                  name="ipgoticketjundal"
                  size="small"
                  value={ipgoticketjundal ? ipgoticketjundal : ''}
                />
              </div>
              <div>
                <CssTextField
                  style={{ marginRight: 2 }}
                  id="datetime-local"
                  size="small"
                  label="업체입고요청일자"
                  variant="outlined"
                  type="datetime-local"
                  format="YYYY-MM-DD HH:mm"
                  value={
                    ipgoyoochengil
                      ? ipgoyoochengil
                      : setIpgoyoochengil(moment().format('YYYY-MM-DD HH:mm'))
                  }
                  className={classes.textField}
                  onChange={ipgoyoochengilHandle}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <DisabledTextField
                  disabled
                  id="datetime-local"
                  size="small"
                  label="등록일자"
                  variant="outlined"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm"
                  value={
                    ipgodatetime
                      ? ipgodatetime
                      : setIpgodatetime(moment().format('YYYY-MM-DD HH:mm'))
                  }
                  className={classes.textField}
                  onChange={ipgodatetimeHandle}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <div style={{ marginTop: '10px' }}>
              {
                btnunable ? (
                  <Button
                    onClick={buttonClickHeandle}
                    onMouseUp={buttonClickHeandle}
                    type="submit"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    style={{
                      height: '37px',
                      background: '#388e3c',
                      color: 'white',
                      width: 100,
                      marginTop: '2px',
                      marginRight: '2px',
                      float: 'center',
                    }}
                  >
                    등록
                  </Button>
                ) : (
                  <Button
                      onClick={buttonClickHeandle}
                      onMouseUp={buttonClickHeandle}
                    type="submit"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    disabled
                    style={{
                      height: '37px',
                      background: '#ef5350',
                      color: 'white',
                      width: 100,
                      marginTop: '2px',
                      marginRight: '2px',
                      float: 'center',
                    }}
                  >
                    등록
                  </Button>
                )
              }
              <Button
                onClick={() => {
                  props.setAdd(false);
                }}
                variant="contained"
                startIcon={<SaveIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                닫기
              </Button>
              <Button
                variant="contained"
                style={{
                  height: '37px',
                  background: '#afb42b',
                  color: 'white',
                  width: 100,
                  marginTop: '2px',
                  marginLeft: '2px',
                  float: 'center',
                }}
                onClick={onPrintHandler}
              >
                Print
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  setBtneuable(true);
                }}
                onMouseUp={clearclickHandle}  //화면 크리어
                style={{
                  background: '#ef5350',
                  color: 'white',
                  textAlign: 'center',
                  float: 'right',
                }}
              >
                <i className="fa-solid fa-reply"></i> 해제
              </Button>
            </div>
          </Form>
        </Box>
      </Modal>
      {copen === true ? (
        <IpgoItemSerche
          copen={copen}
          setCopen={setCopen}
          dataItem={dataItem}
          setDbClickValue={setDbClickValue}
        />
      ) : null}
      {customergumsaopen === true ? (
        <IpgoGumsa
          customergumsaopen={customergumsaopen}
          setCustomergumsaopen={setCustomergumsaopen}
          setGumsajahangmug={setGumsajahangmug}
        />
      ) : null}
      {ipgoprintopen === true ? (
        <IpgoPrint
          ipgoprintopen={ipgoprintopen}
          setIpgoprintopen={setIpgoprintopen}
          ipgoprintmove={ipgoprintmove}
        />
      ) : null}
    </div>
  );
}

export default IpgoCreate;
